module.exports = __webpack_public_path__ + "img/sonac_card.69a01541.jpg";